import JSONController from './JSONController';
class TranslationsStatistics {
    constructor() {
        this.controller = new JSONController();
        this.translations = [];
        this.sentTranslations = [];
        this.pushTranslation = (app, key) => {
            const translation = `${app}:${key}`;
            if (!this.translations.includes(translation)) {
                this.translations.push(translation);
            }
        };
        this.stopStatistics = () => {
            if (this.processId) {
                clearTimeout(this.processId);
            }
        };
        this.startStatistics = (url) => {
            this.stopStatistics();
            this.processId = setInterval(() => {
                this.sendData(url);
            }, 5000);
        };
        this.sendData = (url) => {
            let tempTranslations = this.translations.splice(0, this.translations.length);
            tempTranslations = tempTranslations.filter((str) => !this.sentTranslations.includes(str));
            if (tempTranslations.length) {
                try {
                    this.controller.put(url, tempTranslations);
                }
                catch (e) {
                    console.error(e);
                }
                this.sentTranslations = this.sentTranslations.concat(tempTranslations);
            }
        };
    }
}
export default TranslationsStatistics;
